import { createApp } from 'vue'
import App from './App.vue'
import toast from '@/components/tf-toast'
import loading from '@/components/tf-loading'
const app = createApp(App)
app.config.globalProperties.$toast = toast
app.use(loading)
app.mount('#app')